<template>
    <b-container fluid>
        <div v-if="wizardData" class="mb-3">
            <div class="d-flex justify-content-between align-items-center pt-3">
                <div>
                    <b>{{ wizardData.name }} - Custom Variables</b>
                </div>
            </div>
            <div class="pt-3">
                <div>
                    The fields below are provided as a courtesy.
                    They represent sample fields that a property manager might utlize when communicating with a guest.
                </div>
                <div class="pt-1">
                    To add your own custom fields, please go to the
                    <a href="/app/custom-variable/property-variables/">Custom Variables</a>
                    area of the application.
                </div>
                <div class="pt-1">
                    The data below is not shared or sync'd with any of the channels.
                </div>
            </div>
            <hr />
        </div>
        <div v-for="item in custom" :key="item.custom_variable_id" class="mb-4 mb-md-0">
            <b-row class="flex-column flex-md-row">
                <b-col class="pr-md-2">
                    <form-textarea
                        v-if="item.rows > 1"
                        v-model="item.value"
                        :floatingLabel="item.title"
                        :rows="item.rows"
                        :leftIcon="['fas', 'arrow-right']"
                        class="pr-md-0 pr-2"
                    />
                    <form-input
                        v-else
                        v-model="item.value"
                        :floatingLabel="item.title"
                        :rows="item.rows"
                        :leftIcon="['fas', 'arrow-right']"
                        class="pr-md-0 pr-2"
                    />
                </b-col>
                <b-col class="pr-md-2">
                    
                    <form-select
                        class="pr-md-0 pr-2"
                        @input="(val) => {
                            item.guestapp_location = val;
                        }"
                        :options="item.guestapp_location_choices"
                        :value="item.guestapp_location"
                        floatingLabel="Staylio App Location"
                        :leftIcon="['fas', 'mobile-screen-button']"
                    />
                </b-col>
            </b-row>

        </div>
        <b-button
            variant="primary"
            @click="saveCustom"
            >Save</b-button
        >
    </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatResponseError } from '../../../../utils/api';
import FormTextarea from '../../../generic/form-textarea/form-textarea.vue';
import FormInput from '../../../generic/form-input/form-input.vue';
import FormDropdown from '../../../generic/form-dropdown/form-dropdown.vue';
import FormSelect from '../../../generic/form-select/form-select.vue';

export default {
    components: {
        FormTextarea,
        FormInput,
        FormDropdown,
        FormSelect,
    },
    inject: ['propertyId', 'getModuleEndpointAndBody'],
    mounted() {
        this.fetchCustom();
    },
    computed: {
        ...mapGetters('setupPropertyStore', [
            'wizardData',
            'initialData',
            'custom',
        ]),
    },
    methods: {
        async fetchCustom() {
            try {
                this.$parent.$emit('busy', true);
                await this.$store.dispatch('setupPropertyStore/getCustom', {
                    propertyId: this.propertyId,
                });
            } catch (e) {
                const { generic } = formatResponseError(e);
                this.errorToast({
                    text: generic || 'Could not fetch custom variables',
                });
            } finally {
                this.$parent.$emit('busy', false);
            }
        },
        async saveCustom() {
            try {
                this.$parent.$emit('busy', true);
                const data = this.getModuleEndpointAndBody();
                await this.$store.dispatch(
                    'setupPropertyStore/saveModule',
                    data
                );
                this.successToast({
                    text: 'Custom Variables successfully saved',
                });
            } catch (e) {
                const { generic } = formatResponseError(e);
                this.errorToast({
                    text: generic || 'Could not save custom variables',
                });
            } finally {
                this.$parent.$emit('busy', false);
            }
        },
    },
};
</script>

<style>
</style>